import { Block } from 'ui-kit/blocks'
import { Heading, Text } from 'ui-kit/typography'
import { Actions, Link } from 'ui-kit/actions'
import { DOCS_LINK } from 'routes/constants'
import { BookCalendlyLink } from 'routes/components/Shared'
import HeroVideoMobileMp4 from './hero-mob.mp4'
import HeroVideoMobileWebm from './hero-mob.webm'
import HeroImageMobile from './hero-mob.avif'
import classes from './DataIntegrationToolsHero.module.scss'

export const DataIntegrationToolsHero = () => {
  return (
    <Block
      as={'section'}
      variant={'shadowMob'}
      divider={'mobile'}
      className={classes.section}
    >
      <div className={classes.content}>
        <Heading as={'h1'} size={'xxl'} center className={classes.title}>
          Scaling connectors for Data Integration Platforms
        </Heading>
        <Text size={'lg'} center balance className={classes.subtitle}>
          Accelerate your integration roadmap using connectors that seamlessly
          fit your existing integration framework.
        </Text>
        <Actions className={classes.actions}>
          <BookCalendlyLink
            type={'primary'}
            showIcon={false}
            className={classes.button}
          >
            Schedule a personalized demo
          </BookCalendlyLink>
          <Link
            href={DOCS_LINK}
            type={'secondary'}
            target={'_blank'}
            asPageButton
            className={classes.button}
          >
            Read the docs
          </Link>
        </Actions>
      </div>
      <div className={classes.visual}>
        <div className={classes.video}>
          <video
            autoPlay={true}
            loop={true}
            muted={true}
            playsInline={true}
            controls={false}
            poster={HeroImageMobile.src}
            fetchpriority={'high'}
          >
            <source src={HeroVideoMobileWebm} type='video/webm' />
            <source src={HeroVideoMobileMp4} type='video/mp4' />
            <img
              loading='lazy'
              width={1200}
              height={1200}
              src={HeroImageMobile.src}
              aria-hidden='true'
              alt='Universal Connectors'
            />
          </video>
        </div>
      </div>
    </Block>
  )
}
